import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom';

export default function RemoveMemList() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/projectlist'); 
  }, [navigate]); 
  return null; 
}
